import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './StunningCard.css'; // We'll create this next

function StunningCard() {
  const [name, setName] = useState('');

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="card p-4 text-center stunning-card">
        <h2 className="mb-4 text-primary">💫 Welcome!</h2>
        <input
          type="text"
          className="form-control glow-input"
          placeholder="Enter your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <div className="greeting">
          {name && `Hello, ${name}! 👋`}
        </div>
      </div>
    </div>
  );
}

export default StunningCard;
